/**
 * BMM — Clothio Edits Slider
 * File: bmm-edits-slider.js
 * Version: 1.0
 * Mockup ref: Clothio_Homepage_Final.html — SECTION 6 JS
 * ─────────────────────────────────────────────────────
 * Exact replication of the approved mockup slider logic:
 *  - Desktop: left/centre/right absolute positioned cards
 *  - Mobile: depth-wheel via data-slot + perspective CSS
 *  - Auto-advance, pause on hover, resume on leave
 *  - Pointer drag (desktop) + touch swipe (mobile)
 *  - Gold progress bar resets on each advance
 *  - IntersectionObserver: pause when off-screen
 */

(function () {
  'use strict';

  function initSlider(section) {
    var sid       = section.dataset.sectionId;
    var speed     = parseInt(section.dataset.autoSpeed, 10) || 3200;
    var track     = document.getElementById('bmmEditsTrack-' + sid);
    var prog      = document.getElementById('bmmEditsProg-' + sid);
    var btnP      = document.getElementById('bmmEditsPrev-' + sid);
    var btnN      = document.getElementById('bmmEditsNext-' + sid);
    var infoPanel = document.getElementById('bmmEditsInfo-' + sid);
    var nameEl    = document.getElementById('bmmEditsName-' + sid);
    var subEl     = document.getElementById('bmmEditsSub-' + sid);
    var ctaEl     = document.getElementById('bmmEditsCta-' + sid);
    var dotsWrap  = document.getElementById('bmmEditsDots-' + sid);

    if (!track) return;

    /* ── BUILD CARD DOM FROM DATA ATTRIBUTES ── */
  var cardEls = Array.from(track.querySelectorAll('.bmm-ecard'))
  .filter(function(card){
    return !card.classList.contains('clone');
  });

var N = cardEls.length;
if (N === 0) return;

dotsWrap.innerHTML = '';

    /* Populate each card with image + overlay + CTA */
    cardEls.forEach(function (card) {
      var img_src = card.dataset.img;
      var alt     = card.dataset.alt || '';
      var voice   = card.dataset.voice || '1';
      var line1   = card.dataset.line1 || '';
      var line2   = card.dataset.line2 || '';
      var sub     = card.dataset.sub   || '';

      /* Image */
      if (img_src) {
        var img = document.createElement('img');
        img.src = img_src;
        img.alt = alt;
        img.draggable = false;
        img.loading = 'lazy';
        card.appendChild(img);
      }

      /* Overlay — heading + sub */
      var ov  = document.createElement('div');
      ov.className = 'bmm-eov';

      var nm = document.createElement('div');
      nm.className = 'bmm-ev' + voice;
      nm.innerHTML = line1 + (line2 ? '<br>' + line2 : '');
      /* Hardcode font so Ella global CSS cannot override JS-inserted nodes */
      nm.style.fontFamily = "'Cormorant Garamond', Georgia, serif";

      var sb = document.createElement('div');
      sb.className = 'bmm-esub';
      sb.textContent = sub;

      ov.appendChild(nm);
      ov.appendChild(sb);
      card.appendChild(ov);

      /* Shop CTA — text from data-cta attr or fallback */
      var cta = document.createElement('span');
      cta.className = 'bmm-ecta';
      cta.textContent = card.dataset.cta || 'Shop the Edit →';
      card.appendChild(cta);
    });

    /* ── STATE ── */
    var cur    = 0;
    var locked = false;
    var timer  = null;
    var paused = false;

    function mod(i) { return ((i % N) + N) % N; }
    function isMob() { return window.innerWidth <= 768; }

    /* ── DESKTOP RENDER ── */
    function renderDesktop(animate) {
      var prevIdx   = mod(cur - 1);
      var centreIdx = mod(cur);
      var nextIdx   = mod(cur + 1);

      if (!animate) {
        cardEls.forEach(function (nd) { nd.style.transition = 'none'; });
        track.getBoundingClientRect(); /* force reflow */
      }

      cardEls.forEach(function (nd, i) {
        nd.removeAttribute('data-slot');
        var cls;
        if      (i === prevIdx)   cls = 'bmm-ecard bmm-ecard-side bmm-epos-left';
        else if (i === centreIdx) cls = 'bmm-ecard bmm-ecard-centre bmm-epos-centre';
        else if (i === nextIdx)   cls = 'bmm-ecard bmm-ecard-side bmm-epos-right';
        else {
          var dist = mod(i - centreIdx);
          cls = (dist <= Math.floor(N / 2))
            ? 'bmm-ecard bmm-ecard-side bmm-epos-off-right'
            : 'bmm-ecard bmm-ecard-side bmm-epos-off-left';
        }
        nd.className = cls;
      });

      if (!animate) {
        requestAnimationFrame(function () {
          cardEls.forEach(function (nd) { nd.style.transition = ''; });
        });
      }
    }

    /* ── MOBILE WHEEL RENDER ── */
    function renderWheel(animate) {
      if (!animate) {
        cardEls.forEach(function (nd) { nd.style.transition = 'none'; });
        track.getBoundingClientRect();
      }

      cardEls.forEach(function (nd, i) {
        nd.className = 'bmm-ecard';
        var dist = mod(i - cur);
        var slot;
        if      (dist === 0)     slot = 'c';
        else if (dist === 1)     slot = 'r1';
        else if (dist === 2)     slot = 'r2';
        else if (dist === N - 1) slot = 'l1';
        else if (dist === N - 2) slot = 'l2';
        else                     slot = 'off';
        nd.setAttribute('data-slot', slot);
      });

      if (!animate) {
        requestAnimationFrame(function () {
          cardEls.forEach(function (nd) { nd.style.transition = ''; });
        });
      }

      updateInfo();
    }

    function render(animate) {
      if (isMob()) renderWheel(animate);
      else         renderDesktop(animate);
    }

    /* ── PROGRESS BAR ── */
    function runBar() {
      if (!prog) return;
      /* Remove run class, force reflow, re-add — restarts animation */
      prog.className = 'bmm-edits__prog';
      prog.style.animationDuration = '';
      void prog.offsetWidth;
      /* Set animation-duration directly on element — avoids CSS var scoping issues */
      prog.style.animationDuration = (speed / 1000) + 's';
      prog.className = 'bmm-edits__prog run';
    }

    /* ── GO TO SLIDE ── */
    function go(newCur) {
      if (locked) return;
      locked = true;
      cur = mod(newCur);
      render(true);
      runBar();
      setTimeout(function () { locked = false; }, 530);
    }

    function next() { go(cur + 1); }
    function prev() { go(cur - 1); }

    /* ── AUTO ADVANCE ── */
    function startTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, speed);
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    /* ── MOBILE INFO PANEL ── */
    function updateInfo() {
      if (!infoPanel) return;
      var card = cardEls[cur];
      if (!card) return;
      if (nameEl) nameEl.textContent = card.dataset.line1 + (card.dataset.line2 ? ' ' + card.dataset.line2 : '');
      if (subEl)  subEl.textContent  = card.dataset.sub || '';
      if (ctaEl)  ctaEl.href         = card.dataset.url || '/collections/all';
      /* Update dots */
      var dots = dotsWrap ? dotsWrap.querySelectorAll('.bmm-edits__wheel-dot') : [];
      dots.forEach(function (d, i) { d.classList.toggle('on', i === cur); });
    }

    /* ── INIT MOBILE UI ── */
    function initWheelUI() {
      if (!dotsWrap || !infoPanel) return;

      function toggleInfo() {
        infoPanel.style.display = isMob() ? 'block' : 'none';
      }
      toggleInfo();
      window.addEventListener('resize', toggleInfo, { passive: true });

      /* Build dots */
      cardEls.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.className = 'bmm-edits__wheel-dot' + (i === 0 ? ' on' : '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        btn.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(btn);
      });
    }

    /* ── INIT ── */
    initWheelUI();

    /* Double rAF ensures CSS is parsed before positioning */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        render(false);
        runBar();
        /* Small delay before starting timer — ensures section is fully rendered */
        setTimeout(function () {
          startTimer();
        }, 200);
      });
    });

    /* ── ARROWS ── */
    if (btnN) btnN.addEventListener('click', function () { next(); stopTimer(); startTimer(); });
    if (btnP) btnP.addEventListener('click', function () { prev(); stopTimer(); startTimer(); });

    /* ── HOVER PAUSE (desktop) ── */
    var clip = track.closest('.bmm-edits__clip');
    if (clip) {
      clip.addEventListener('mouseenter', function () { stopTimer(); }, { passive: true });
      clip.addEventListener('mouseleave', function () { if (!paused) startTimer(); }, { passive: true });
    }

    /* ── POINTER DRAG / TOUCH SWIPE ── */
    var sx = 0, pointerDown = false, moved = false;

    track.addEventListener('pointerdown', function (e) {
      sx = e.clientX;
      pointerDown = true;
      moved = false;
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!pointerDown) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 6) moved = true;
      if (Math.abs(dx) > 44) {
        pointerDown = false;
        stopTimer();
        if (dx < 0) next(); else prev();
        startTimer();
      }
    });

    track.addEventListener('pointerup', function (e) {
      if (moved) e.preventDefault();
      pointerDown = false;
      moved = false;
    });

    /* ── INTERSECTION OBSERVER — pause off-screen ── */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          paused = !entry.isIntersecting;
          if (paused) stopTimer();
          else startTimer();
        });
      }, { threshold: 0.1 });
      obs.observe(section);
    }

    /* ── KEYBOARD ── */
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { prev(); stopTimer(); startTimer(); }
      if (e.key === 'ArrowRight') { next(); stopTimer(); startTimer(); }
    });
  }

  /* ── FIND ALL INSTANCES ── */
  function init() {
    document.querySelectorAll('.bmm-edits[data-section-id]').forEach(function (section) {
      initSlider(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── THEME EDITOR ── */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.bmm-edits[data-section-id]');
    if (section) initSlider(section);
  });

})();
